import { component } from 'knockout-decorators'

import source from './template.html?raw'
import './style.less'

const HUBSPOT_SCRIPT_URL = 'https://js-eu1.hsforms.net/forms/embed/146722707.js'

@component('hubspot-form-content', source)
export class HubspotFormContent {
  private scriptLoaded = false

  initForm = (element: HTMLElement) => {
    if (this.scriptLoaded) return
    this.scriptLoaded = true

    const script = document.createElement('script')
    script.src = HUBSPOT_SCRIPT_URL
    script.async = true
    element.appendChild(script)
  }

  constructor() {
    //
  }
}
